import React from 'react';

import {translate} from 'iss/strings';
import {SelectableTable} from 'iss/widgets/SelectableTable';
import {Table} from 'iss/widgets/bootstrap/Table';

export function QuestionList({questions, selectable = false, compact = false, extraColumns = [], ...props}) {
  const TableComponent = selectable ? SelectableTable : Table;
  const columns = compact ? compactColumns : defaultColumns;
  return <TableComponent id="questions-list" data={questions}
    {...props}
    columns={extraColumns.length > 0 ? [...columns, ...extraColumns] : columns}
  />;
}

const defaultColumns = [
  {
    header: translate('domain.question.id'),
    cellProps: {className: "question-id" },
    accessor: question => question.id
}, {
    header: translate('domain.question.name'),
    cellProps: {className: "question-name" },
    accessor: question => question.name
  }, {
    header: translate('domain.question.description'),
    cellProps: {className: "question-description" },
    accessor: question => question.description
  }, {
    header: translate('domain.question.headingTitle'),
    cellProps: {className: "question-heading-title" },
    accessor: question => question.headingTitle
  }, {
    header: translate('domain.question.formName'),
    cellProps: {className: "question-form-name" },
    accessor: question => question.formName
  }, {
    header: translate('domain.question.groups'),
    cellProps: {className: "question-groups" },
    accessor: getQuestionGroups
  },
];

const compactColumns = [
  {
    header: translate('domain.question.id'),
    cellProps: {className: "question-id" },
    accessor: question => question.id
  }, {
    header: translate('domain.question.name'),
    cellProps: {className: "question-name" },
    accessor: question => question.name
  }, {
    header: translate('domain.question.formName'),
    cellProps: {className: "question-form-name" },
    accessor: question => question.formName
  }, {
    header: translate('domain.question.groups'),
    cellProps: {className: "question-groups" },
    accessor: getQuestionGroups
  },
];

function getQuestionGroups({questionGroups}) {
  return questionGroups.map(group => group.description).join(", ");
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/QuestionList.jsx